import { gql, useQuery } from "@apollo/client";

const GetStudentPlanStatisticsQuery = gql`
  query getStudentPlanStatistics {
    getStudentPlanStatistics {
      activeGroupPlanStudentCount
      activeOneOnOnePlanStudentCount
      activePlanStudentCount
      planEndingWithinDays
      studentsWithGroupPlanEndingSoonCount
      studentsWithOneOnOnePlanEndingSoonCount
      activePlanStudentsByLevel {
        speakingLevel
        studentCount
      }
      studentsWithExhaustedLessonPack {
        userId
        givenName
        familyName
        email
        speakingLevel
        userGroupName
        planEndUtc
        lessonPackSize
        usedLessons
        nextBookedLessonStartUtc
      }
    }
  }
`;

export type StudentLevelCount = {
  speakingLevel: string;
  studentCount: number;
};

export type ExhaustedLessonPackStudent = {
  userId: string;
  givenName: string;
  familyName: string;
  email: string;
  speakingLevel: string;
  userGroupName: string | null;
  planEndUtc: string;
  lessonPackSize: number;
  usedLessons: number;
  nextBookedLessonStartUtc: string | null;
};

export type StudentPlanStatistics = {
  activeGroupPlanStudentCount: number;
  activeOneOnOnePlanStudentCount: number;
  activePlanStudentCount: number;
  planEndingWithinDays: number;
  studentsWithGroupPlanEndingSoonCount: number;
  studentsWithOneOnOnePlanEndingSoonCount: number;
  activePlanStudentsByLevel: StudentLevelCount[];
  studentsWithExhaustedLessonPack: ExhaustedLessonPackStudent[];
};

export function useStudentPlanStatistics() {
  const { data, loading, error } = useQuery<{
    getStudentPlanStatistics: StudentPlanStatistics;
  }>(GetStudentPlanStatisticsQuery, { fetchPolicy: "cache-and-network" });

  return {
    statistics: data?.getStudentPlanStatistics ?? null,
    loading: loading && !data,
    error,
  };
}
